// extracted by mini-css-extract-plugin
export default {"main_actions_content":"MainAction_main_actions_content__GUtZL","main_actions_button_money_transfer":"MainAction_main_actions_button_money_transfer__UcRAo"};